import { type EventFlow } from '@solinkcorp/api-types';
import { userHasFeature, useUserSession, type UserSession } from '@solinkcorp/authentication';
import { type IEvent } from 'clients/PlatformApi';
import { isAlarm, isEventIdInvalid } from 'utils/EventUtil';

export function canEventBeVerified(
  event: IEvent,
  verificationWorkflow: EventFlow | undefined,
  user: UserSession,
  isAlarms?: boolean,
) {
  if (isAlarms || isAlarm(event)) {
    return false;
  }

  const canAccessEventFlow = userHasFeature(user, 'eventFlowResponse');
  const allowEdit = !isEventIdInvalid(event.id);
  const isEventVerified = !!event.details?.verificationConclusion;
  return allowEdit && canAccessEventFlow && (!!verificationWorkflow || isEventVerified);
}

function useCanEventBeVerified(
  event: IEvent,
  verificationWorkflow: EventFlow | undefined,
  isAlarms?: boolean,
) {
  const user = useUserSession();
  return {
    canBeVerified: canEventBeVerified(event, verificationWorkflow, user, isAlarms),
  };
}

export default useCanEventBeVerified;
